var _circle, _g, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginimagem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 43,
    viewBox: "0 0 46 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0469 29.7H13.9539C13.1416 29.7 12.5417 28.8984 12.8481 28.1613C14.2697 24.7527 17.6095 22.8 21.4998 22.8C25.3914 22.8 28.7311 24.7527 30.1528 28.1613C30.4592 28.8984 29.8593 29.7 29.0469 29.7ZM16.8042 15.9C16.8042 13.3631 18.9113 11.3 21.4998 11.3C24.0895 11.3 26.1955 13.3631 26.1955 15.9C26.1955 18.4369 24.0895 20.5 21.4998 20.5C18.9113 20.5 16.8042 18.4369 16.8042 15.9ZM32.949 29.2814C32.0956 25.4185 29.4261 22.5677 25.9126 21.2739C27.7744 19.8054 28.8603 17.4306 28.4611 14.8304C27.9986 11.814 25.4371 9.40017 22.3451 9.04827C18.0767 8.56182 14.4563 11.8163 14.4563 15.9C14.4563 18.0735 15.4847 20.0101 17.0883 21.2739C13.5736 22.5677 10.9052 25.4185 10.0506 29.2814C9.74071 30.6855 10.8958 32 12.3621 32H30.6376C32.105 32 33.2601 30.6855 32.949 29.2814Z",
    fill: "black"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 8,
    r: 8,
    fill: "#FF9D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.662 4.878C35.662 4.234 35.8907 3.68333 36.348 3.226C36.8053 2.76866 37.356 2.54 38 2.54C38.644 2.54 39.1947 2.76866 39.652 3.226C40.1093 3.68333 40.3427 4.234 40.352 4.878C40.352 4.95266 40.3427 5.018 40.324 5.074L39.554 8.112C39.526 8.52266 39.3627 8.868 39.064 9.148C38.7653 9.428 38.4107 9.568 38 9.568C37.5987 9.568 37.2487 9.43266 36.95 9.162C36.6513 8.89133 36.4833 8.55533 36.446 8.154C36.3527 7.874 36.2547 7.566 36.152 7.23C36.0493 6.894 35.942 6.488 35.83 6.012C35.718 5.536 35.662 5.158 35.662 4.878ZM36.432 11.906C36.432 11.4767 36.586 11.1127 36.894 10.814C37.202 10.5153 37.5707 10.3613 38 10.352C38.4293 10.3427 38.798 10.4967 39.106 10.814C39.414 11.1313 39.568 11.4953 39.568 11.906C39.568 12.3447 39.414 12.7133 39.106 13.012C38.798 13.3107 38.4293 13.4647 38 13.474C37.5707 13.4833 37.202 13.3293 36.894 13.012C36.586 12.6947 36.432 12.326 36.432 11.906Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginimagem);
export default __webpack_public_path__ + "static/media/login imagem.c91c5e760987cc27219febde9986a25c.svg";
export { ForwardRef as ReactComponent };